import { CommonModule } from "@angular/common";
import { WholesalerIntegrationDialogComponent } from "./wholesaler-integration-dialog.component";
import { ButtonModule } from "src/app/shared/components/button/button.module";
import { SelectTypeComponent } from "./gather-credentials/gather-credentials.component";
import { TestConnectionComponent } from "./test-connection/test-connection.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { AlertModule } from "src/app/shared/components/alert/alert.module";
import { InputModule } from "src/app/shared/components/input/input.module";
import { InputSearchScannerModule } from "src/app/shared/components/input-search-scanner/input-search-scanner.module";
import { EditProfileDialogComponent } from "../edit-profile-dialog/edit-profile-dialog.component";
import { DialogModule } from "src/app/shared/components/dialog/dialog.module";
import { PinInputModule } from "src/app/shared/components/pin-input/pin-input.module";
import { OptionsListModule } from "src/app/shared/components/options-list/options-list.module";
import { InventoryLocationsDropdownModule } from "src/app/shared/components/inventory-locations-dropdown/inventory-locations-dropdown.module";

@NgModule({
    declarations: [
        WholesalerIntegrationDialogComponent,
        SelectTypeComponent,
        TestConnectionComponent,
        EditProfileDialogComponent,
    ],
    imports: [
      CommonModule,
      ButtonModule,
      FormsModule,
      ReactiveFormsModule,
      AlertModule,
      InputModule,
      InputSearchScannerModule,
      DialogModule,
      PinInputModule,
      OptionsListModule,
      InventoryLocationsDropdownModule
    ],
    exports: [
        WholesalerIntegrationDialogComponent, EditProfileDialogComponent
    ],
  })
  export class WholesalerIntegrationDialogModule {
  }